import integrationUtils from "../../Utils/integration.utils";
import ImageLoader from "../Common/ImageLoader";

const ToolIcon = ({ toolId, toolIcon, defaultImage = "/images/attack-surface/generic2-dark.svg", ...props }) => {
  const image = integrationUtils.getImagePath(toolId, toolIcon);
  return (
    <ImageLoader
      alt=""
      {...props}
      src={image}
      noImageComponent={(
        <img
          alt=""
          {...props}
          src={defaultImage}
        />
      )}
    />
  );
};

export default ToolIcon;
